
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LabourMasterSelectDialog extends Serenity.TemplatedDialog<LabourMasterRow> {

        protected getLocalTextPrefix() { return LabourMasterRow.localTextPrefix; }

        private serviceGrid = new LabourMasterSelectGrid(this.byId('serviceGrid'));
        public form;

        constructor() {
            super();

            var tb = this.element.find('.s-DialogToolbar');
            this.element.append(tb);
            this.dialogTitle = "Select Labour Charge";
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            let prior = $(".ui-dialog").eq(-2);
            if (prior.length > 0) {
                $(document).one("dialogopen", (e) => {
                    this.element.dialog().dialog('option', 'position', { my: 'left top', at: 'left+24 top+24', of: prior[0] });
                })
            }
        }

        getToolbarButtons() {
            return [{
                title: 'ОК',
                cssClass: 'ok-button',
                onClick: () => this.okClick()
            }, {
                title: 'Cancel',
                cssClass: 'cancel-button',
                onClick: () => { this.dialogClose(); }
            }];
        }


        public okClick() {
          /*  var items = this.serviceGrid.selectedItems;
            this.element.trigger(<any>{
                type: 'okClick',
                selectedItems: items
            });
            return items;*/
        }
        public getdata() {
            var items = this.serviceGrid.selectedItems;
            this.element.trigger(<any>{
                type: 'okClick',
                selectedItems: items
            });
            return items;
        }

        protected getTemplate() {
            return (
                "<form id='~_Form' class='s-Form'>" +
                "<div id='~_serviceGrid'></div>" +
                "</form>" +
                "<div id='~_Toolbar' class='s-DialogToolbar' ></div>");
        }
    }

}